export const EXECUTIVE_INDUSTRY_LIST = "EXECUTIVE_INDUSTRY_LIST";
export const EXECUTIVE_GEOLOCATION = "EXECUTIVE_GEOLOCATION";
export const EXECUTIVE_COMPANY_TYPE = "EXECUTIVE_COMPANY_TYPE";
export const EXECUTIVE_EMPLOYEE_COUNT = "EXECUTIVE_EMPLOYEE_COUNT";
export const EXECUTIVE_REVENUE_RANGE = "EXECUTIVE_REVENUE_RANGE";
export const EXECUTIVE_COMPANYLIST = "EXECUTIVE_COMPANYLIST";
export const EXECUTIVE_COMPANY_SEARCH_PAYLOAD =
  "EXECUTIVE_COMPANY_SEARCH_PAYLOAD";
export const EXECUTIVE_ADVANCED_SELECTED_FILTERS =
  "EXECUTIVE_ADVANCED_SELECTED_FILTERS";
export const EXECUTIVE_PAGINATION_VALUE = "EXECUTIVE_PAGINATION_VALUE";
export const EXECUTIVE_SELECTED_RECORDS = "EXECUTIVE_SELECTED_RECORDS";
export const EXECUTIVE_SAVE_SEARCH = "EXECUTIVE_SAVE_SEARCH";
export const EXECUTIVE_SAVE_SEARCH_LIST = "EXECUTIVE_SAVE_SEARCH_LIST";
export const EXECUTIVE_COMPANY_TAG_LIST = "EXECUTIVE_COMPANY_TAG_LIST";
export const EXECUTIVE_EMPLOYEELIST = "EXECUTIVE_EMPLOYEELIST";
export const EXECUTIVE_EMPLOYEE_SEARCH_PAYLOAD =
  "EXECUTIVE_EMPLOYEE_SEARCH_PAYLOAD";
export const EXECUTIVE_FUNCTION_LIST = "EXECUTIVE_FUNCTION_LIST";
export const EXECUTIVE_LEVEL_LIST = "EXECUTIVE_LEVEL_LIST";
export const GET_RELAVANT_EXECUTIVE_TAG = "GET_RELAVANT_EXECUTIVE_TAG";
export const EXECUTIVEQUICKSELECTIONLIST = "EXECUTIVEQUICKSELECTIONLIST";

export const EXECUTIVE_EMPTY_ERROR_OBJ_LISTING = "EMPTY_ERROR_OBJ_LISTING";
export const EXECUTIVE_INDUSTRY_LIST_ERROR = "EXECUTIVE_INDUSTRY_LIST_ERROR";
export const EXECUTIVE_GEOLOCATION_ERROR = "EXECUTIVE_GEOLOCATION_ERROR";
export const EXECUTIVE_COMPANY_TYPE_ERROR = "EXECUTIVE_COMPANY_TYPE_ERROR";
export const EXECUTIVE_EMPLOYEE_COUNT_ERROR = "EXECUTIVE_EMPLOYEE_COUNT_ERROR";
export const EXECUTIVE_REVENUE_RANGE_ERROR = "EXECUTIVE_REVENUE_RANGE_ERROR";
export const EXECUTIVE_COMPANYLIST_ERROR = "EXECUTIVE_COMPANYLIST_ERROR";
export const EXECUTIVE_COMPANY_SEARCH_PAYLOAD_ERROR =
  "EXECUTIVE_COMPANY_SEARCH_PAYLOAD_ERROR";
export const EXECUTIVE_ADVANCED_SELECTED_FILTERS_ERROR =
  "EXECUTIVE_ADVANCED_SELECTED_FILTERS_ERROR";
export const EXECUTIVE_PAGINATION_VALUE_ERROR =
  "EXECUTIVE_PAGINATION_VALUE_ERROR";
export const EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR =
  "EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR";
export const EXECUTIVE_SELECTED_RECORDS_ERROR =
  "EXECUTIVE_SELECTED_RECORDS_ERROR";
export const EXECUTIVE_SAVE_SEARCH_ERROR = "EXECUTIVE_SAVE_SEARCH_ERROR";
export const EXECUTIVE_SAVE_SEARCH_LIST_ERROR =
  "EXECUTIVE_SAVE_SEARCH_LIST_ERROR";
export const EXECUTIVE_COMPANY_TAG_LIST_ERROR =
  "EXECUTIVE_COMPANY_TAG_LIST_ERROR";
export const EXECUTIVE_EMPLOYEELIST_ERROR = "EXECUTIVE_EMPLOYEELIST_ERROR";
export const EXECUTIVE_EMPLOYEE_SEARCH_PAYLOAD_ERROR =
  "EXECUTIVE_EMPLOYEE_SEARCH_PAYLOAD_ERROR";
export const EXECUTIVE_FUNCTION_LIST_ERROR = "EXECUTIVE_FUNCTION_LIST_ERROR";
export const EXECUTIVE_LEVEL_LIST_ERROR = "EXECUTIVE_LEVEL_LIST_ERROR";
export const GET_RELAVANT_EXECUTIVE_TAG_ERROR =
  "GET_RELAVANT_EXECUTIVE_TAG_ERROR";
export const EXECUTIVEQUICKSELECTIONLIST_ERROR =
  "EXECUTIVEQUICKSELECTIONLIST_ERROR";
